import { apiClient } from '@/lib/api-client';

/**
 * Um scope da plataforma, como o back devolve — espelho de `ScopeOutputDto`
 * (monolith, `_shared/domain/scope.ts`). Todos os campos são obrigatórios: a
 * lista é hardcoded no back, então não existe scope sem nome.
 */
export interface Scope {
  id: string;
  /** Slug técnico (`aristo-medq`, `admin-dashboard`…). Rótulo de tela é o `name`. */
  platform: string;
  /** Nome de exibição da plataforma. */
  name: string;
  /**
   * BUs atendidas pela plataforma. **Lista**: a plataforma educacional atende
   * duas no mesmo scope, e os painéis internos não atendem nenhuma (vazio).
   */
  tenants: string[];
}

/**
 * Lista de scopes do Identity (`GET /admin/identity/scopes`), não paginada.
 *
 * Vive em `shared/` e não num módulo porque serve tanto Usuários (seletor de
 * PlatformProfile) quanto Catálogo (exibição de scopes de perks, roles,
 * features e product-perks) — nenhum dos dois é dono do recurso.
 *
 * Instanciada uma única vez abaixo — o consumidor usa o singleton.
 */
class ScopesApiDatasource {
  async listScopes(): Promise<Scope[]> {
    const { data } = await apiClient.get<Scope[]>('/admin/identity/scopes');
    return data;
  }

  /**
   * Os scopes em que o usuário logado pode trazer gente
   * (`GET /admin/identity/provisionable-scopes`): mesma forma da lista acima,
   * já filtrada pelo back pela régua do `grantableByPerkKeys`.
   */
  async listProvisionableScopes(): Promise<Scope[]> {
    const { data } = await apiClient.get<Scope[]>(
      '/admin/identity/provisionable-scopes',
    );
    return data;
  }
}

export const scopesApiDatasource = new ScopesApiDatasource();
